import { render, staticRenderFns } from "./BaseLoader.vue?vue&type=template&id=158a046a&scoped=true&"
var script = {}
import style0 from "./BaseLoader.vue?vue&type=style&index=0&id=158a046a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158a046a",
  null
  
)

export default component.exports